// src/app/elements/calendar/EventsApiCalls.js
import { API_BASE } from "../../../../config/api";

function toISODateLocal(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  const pad = (n) => String(n).padStart(2, "0");
  return `${x.getFullYear()}-${pad(x.getMonth() + 1)}-${pad(x.getDate())}`;
}

export function gridRangeFromDays(days) {
  if (!days?.length) return { from: null, to: null };
  return {
    from: toISODateLocal(days[0].date),
    to: toISODateLocal(days[days.length - 1].date),
  };
}

/**
 * Fetches counts map: { "YYYY-MM-DD": number }
 * Uses same auth headers as your other endpoints.
 */
export async function fetchEventCounts({ from, to, filters = {}, signal } = {}) {
  const sessionData = JSON.parse(localStorage.getItem("sessionData"));
  if (!sessionData?.sessionKey || !sessionData?.username) {
    console.error("Missing session credentials");
    return {};
  }

  const url = `${API_BASE}/events/counts?${new URLSearchParams({
    ...(from ? { from } : {}),
    ...(to ? { to } : {}),
    ...(filters.status ? { status: filters.status } : {}),
    ...(filters.type ? { type: filters.type } : {}),
    ...(filters.location ? { location: String(filters.location) } : {}),
  })}`;
  

  // Optional multi-location header
  const locationsHeader =
    Array.isArray(filters.locations) && filters.locations.length
      ? filters.locations.join(",")
      : undefined;

  const res = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: sessionData.sessionKey,
      Username: sessionData.username,
      ...(locationsHeader ? { Locations: locationsHeader } : {}),
      "Content-Type": "application/json",
    },
    signal,
  });

  if (!res.ok) {
    console.error("Failed to load event counts:", res.status);
    return {};
  }

  const data = (await res.json()) || {};
  console.log("📅 Event counts fetched:", data);
  return data;
}

/** Locked dates **/
export async function fetchLockedDates({ from, to, signal } = {}) {
  const sessionData = JSON.parse(localStorage.getItem("sessionData"));
  if (!sessionData?.sessionKey || !sessionData?.username) return [];

  const url = `${API_BASE}/events/locked-dates?${new URLSearchParams({
    ...(from ? { from } : {}),
    ...(to ? { to } : {}),
  })}`;
  

  const res = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: sessionData.sessionKey,
      Username: sessionData.username,
      "Content-Type": "application/json",
    },
    signal,
  });
  if (!res.ok) return [];
  return await res.json();
}

export async function lockDate({ day, reason }) {
  const sessionData = JSON.parse(localStorage.getItem("sessionData"));
  if (!sessionData?.sessionKey || !sessionData?.username) throw new Error("Missing session");
  const res = await fetch(`${API_BASE}/events/locked-dates`, {
    method: "POST",
    headers: {
      Authorization: sessionData.sessionKey,
      Username: sessionData.username,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ day, reason })
  });
  if (!res.ok) {
    const err = await res.json().catch(()=>({}));
    const msg = err?.message || `Lock failed (${res.status})`;
    throw new Error(msg);
  }
  return await res.json();
}

export async function unlockDate(day) {
  const sessionData = JSON.parse(localStorage.getItem("sessionData"));
  if (!sessionData?.sessionKey || !sessionData?.username) throw new Error("Missing session");
  const res = await fetch(`${API_BASE}/events/locked-dates/${encodeURIComponent(day)}`, {
    method: "DELETE",
    headers: {
      Authorization: sessionData.sessionKey,
      Username: sessionData.username,
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(()=>({}));
    const msg = err?.message || `Unlock failed (${res.status})`;
    throw new Error(msg);
  }
  return await res.json();
}
